<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.533 22.4a6.4 6.4 0 1 1 0 12.8 6.4 6.4 0 0 1 0-12.8Z" fill="currentColor" />
      <path d="M26.533 60.8a6.4 6.4 0 1 1 0 12.8 6.4 6.4 0 0 1 0-12.8Z" fill="currentColor" />
      <path
        d="M39.333 24.533c0-1.178.955-2.133 2.134-2.133H75.6c1.178 0 2.133.955 2.133 2.133v8.534A2.133 2.133 0 0 1 75.6 35.2H41.467a2.133 2.133 0 0 1-2.134-2.133v-8.534Z"
        fill="currentColor"
      />
      <path
        d="M22.267 41.6a2.133 2.133 0 0 0-2.134 2.133v8.534c0 1.178.955 2.133 2.134 2.133h36.266V41.6H22.267Z"
        fill="currentColor"
      />
      <path d="M64.933 41.6h12.8v12.8h-12.8V41.6Z" fill="currentColor" />
      <path
        d="M41.467 60.8a2.133 2.133 0 0 0-2.134 2.133v8.534c0 1.178.955 2.133 2.134 2.133H75.6a2.133 2.133 0 0 0 2.133-2.133v-8.534A2.133 2.133 0 0 0 75.6 60.8H41.467Z"
        fill="currentColor"
      />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
